class CollectionInfiniteScroll extends HTMLElement {
  constructor() {
    super();
    this.loading = false;
    this.ticking = false;
    this.intersectionObserver = null;
    this.mutationObserver = new MutationObserver(() => this.init());
    this.onScroll = this.onScroll.bind(this);
  }

  connectedCallback() {
    this.mutationObserver.observe(this, { childList: true });
    this.init();
  }

  disconnectedCallback() {
    this.mutationObserver.disconnect();
    this.teardownTriggers();
  }

  teardownTriggers() {
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
      this.intersectionObserver = null;
    }
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onScroll);
  }

  init() {
    this.teardownTriggers();
    this.loading = false;

    const sentinel = this.querySelector('.infinite-scroll-sentinel');
    const status = this.querySelector('.infinite-scroll-status');
    const grid = this.querySelector('#product-grid');

    if (!sentinel || !status || !grid || !status.dataset.nextUrl) return;

    this.intersectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) this.loadNextPage();
        });
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    this.intersectionObserver.observe(sentinel);

    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onScroll, { passive: true });

    this.checkSentinelPosition();
  }

  onScroll() {
    if (this.ticking) return;
    this.ticking = true;
    requestAnimationFrame(() => {
      this.ticking = false;
      this.checkSentinelPosition();
    });
  }

  checkSentinelPosition() {
    if (this.loading) return;

    const sentinel = this.querySelector('.infinite-scroll-sentinel');
    const status = this.querySelector('.infinite-scroll-status');
    if (!sentinel || !status || !status.dataset.nextUrl) return;

    const rect = sentinel.getBoundingClientRect();
    if (rect.top <= window.innerHeight + 400) {
      this.loadNextPage();
    }
  }

  loadNextPage() {
    if (this.loading) return;

    const status = this.querySelector('.infinite-scroll-status');
    const grid = this.querySelector('#product-grid');
    const spinner = this.querySelector('.infinite-scroll-spinner');
    const nextUrl = status ? status.dataset.nextUrl : '';

    if (!status || !grid || !nextUrl) return;

    this.loading = true;
    if (spinner) spinner.classList.remove('hidden');

    const sectionId = grid.dataset.id;
    const separator = nextUrl.includes('?') ? '&' : '?';
    const fetchUrl = `${nextUrl}${separator}section_id=${sectionId}`;

    fetch(fetchUrl)
      .then((response) => response.text())
      .then((html) => {
        const parsedHtml = new DOMParser().parseFromString(html, 'text/html');
        const newGrid = parsedHtml.getElementById('product-grid');
        const newStatus = parsedHtml.querySelector('.infinite-scroll-status');

        if (newGrid) {
          Array.from(newGrid.children).forEach((item) => grid.appendChild(item));
        }

        status.dataset.nextUrl = (newStatus && newStatus.dataset.nextUrl) || '';

        if (typeof initializeScrollAnimationTrigger === 'function') {
          initializeScrollAnimationTrigger(this);
        }
      })
      .catch((error) => {
        console.error(error);
        status.dataset.nextUrl = '';
      })
      .finally(() => {
        this.loading = false;
        if (spinner) spinner.classList.add('hidden');
        if (!status.dataset.nextUrl) {
          this.teardownTriggers();
        } else {
          this.checkSentinelPosition();
        }
      });
  }
}

customElements.define('collection-infinite-scroll', CollectionInfiniteScroll);
